import { Button, Icon, Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

export interface ConfirmationFeedbackProps {
  handleRedirectWhatsapp: () => void;
}

export const ConfirmationFeedback: React.FC<ConfirmationFeedbackProps> = ({
  handleRedirectWhatsapp,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  return (
    <VStack
      space={Spacing['stack.xxs']}
      justifyContent={'space-between'}
      alignItems={'center'}
      paddingTop={Spacing['stack.xxxl']}
      paddingBottom={Spacing['stack.xxs']}
      flexDirection={'column'}
      px={Spacing['inline.xxxs']}
      flexGrow={isMobile ? 1 : 0}>
      <VStack alignItems="center">
        <Icon size="xl" color="feedback.attention.default" name="Warning" />
        <Text
          lineHeight="medium"
          textAlign={'center'}
          paddingTop={Spacing['stack.nano']}
          fontSize={Typography['fontsize.xl']}
          fontWeight={Typography['fontweight.light']}>
          Finalize o processo no WhatsApp
        </Text>
        <Text
          lineHeight="medium"
          textAlign={'center'}
          maxWidth={320}
          paddingTop={Spacing['stack.nano']}
          fontSize={Typography['fontsize.md']}
          fontWeight={Typography['fontweight.light']}>
          Estamos quase lá! Para concluir sua operação, por favor, volte ao WhatsApp e finalize o
          processo
        </Text>
      </VStack>

      <Button
        onPress={handleRedirectWhatsapp}
        p={Spacing['inline.nano']}
        w={{ base: 'full', sm: 'sm' }}
        minH={Spacing['inline.sm']}
        _text={{
          fontFamily: Typography['fontfamily.base.semibold'],
          fontSize: Typography['fontsize.md'],
        }}>
        VOLTAR AO WHATSAPP
      </Button>
    </VStack>
  );
};
